import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/dashboard/[id]/insights/page";

export const Route = createFileRoute("/clients/$clientId/dashboard/insights")({
  component: Page,
});
